import './App.scss';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { AuthProvider } from "./context/authContext";

import Login from "./components/Login/Login.js";
import Usuarios from "./pages/Usuarios/Usuarios.js";
import Empresas from "./pages/Empresas/Empresas.js";
import Productos from "./pages/Productos/Productos.js";
import Unauthorized from "./pages/Unauthorized.js";
import Logs from "./pages/Logs/Logs.js";
import Asientos from "./pages/Asientos/Asientos.js";
import Roles from "./pages/Roles/Roles.js";
import Compras from "./pages/Compras/Compras.js";
import Salas from "./pages/Salas/Salas.js";
import Templates from "./pages/Templates/Templates.js";
import TemplateEditor from "./pages/TemplateEditor/TemplateEditor.js";
import Informes from "./pages/Informes/Informes.js";
function App() {
  return (
    <div className="App">
      <BrowserRouter future={{ v7_startTransition: true }}>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/unauthorized" element={<Unauthorized />} />
            {/* Rutas privadas */}
            <Route element={<PrivateRoute requiredPermission={["ver"]}/>}>
              <Route exact path="/usuarios" element={<Usuarios />} />
              <Route exact path="/logs" element={<Logs />} />
              <Route exact path="/empresas" element={<Empresas />} />
              <Route exact path="/productos" element={<Productos />} />
              <Route exact path="/salas/:id" element={<Asientos />} />
              <Route exact path="/roles" element={<Roles />} />
              <Route exact path="/salas" element={<Salas />} />
              <Route exact path="/compras" element={<Compras />} />
              <Route exact path="/templates" element={<Templates />} />
              <Route exact path="/templates/:id" element={<TemplateEditor />} />
              <Route exact path="/informes" element={<Informes />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
    );
}

export default App;
